import { Box } from "@mui/material";
import { useAppSelector } from "@redux";
import React from "react";

const Locale = ({ children }: { children: React.ReactNode }) => {
  const { direction } = useAppSelector((S) => S.Locale);

  return (
    <Box height="100%" dir={direction}>
      {children}
    </Box>
  );
};

export { Locale };
